import { render } from "./GPRChildView.vue?vue&type=template&id=006f2d69&scoped=true"
import script from "./GPRChildView.vue?vue&type=script&lang=js"
export * from "./GPRChildView.vue?vue&type=script&lang=js"

import "./GPRChildView.vue?vue&type=style&index=0&id=006f2d69&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-006f2d69"

export default script